
// Fix Broken Methods in jQuery 2+
// outerWith() without a parameter returns an object. This breaks third party libs that require this functionality.
var oldjQueryOuterWidth = jQuery.fn.outerWidth;
var oldjQueryOuterHeight = jQuery.fn.outerHeight;
jQuery.fn.outerWidth = function(includeMargins) {  return oldjQueryOuterWidth.apply(this, [includeMargins || false]); }
jQuery.fn.outerHeight = function(includeMargins) {  return oldjQueryOuterHeight.apply(this, [includeMargins || false]); }

function recordBookmark(name, id, type, page, elem, url){
    if( typeof(g_flipbook) != "undefined" ){ //mini sharing doesn't get recorded
        var param = "id=" + id + "&type=" + type + "&name="+name+"&page=" + page + "&page_id=" + g_flipbook.page.id;
        $j.ajax({
            type: "GET",
            url: g_webroot + "read/ajax_record_social_bookmark?"+param,
            async:true,
            success: function(){}
        });
    }
    var share_url =  (elem)?$j(elem).attr("href"):url;

    //load in a popup
    loadPage(share_url, 450, 550, true);

    return false;

}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Deprecated Code; do not use..
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// Deprecated; use AppConst.EMPTY
var empty = /^\s*$/;

// Deprecated; use $() or jQuery()
var $j = jQuery.noConflict();

$j( document ).ready( function(){
	
	//disable submit buttons after they're pressed
    // Deprecated; use bootstrap stateful buttons:
    //   see: http://getbootstrap.com/2.3.2/javascript.html#buttons
	$j('input[type=submit].clickonce').bind("click", function(e){
		$j(this).css("display", "none").after("<input class='disabledButton' type='button' disabled='disabled' value='working..'/>");
	});
	
    // Moved to MgmtCommon module
    //  see: /fe/webroot/es5/source/backend/modules/mgmt-common.js
    //       _initAjaxProgressIndicator()
	//bind ajax progress
	$j("#progress").ajaxStart(function(){
		$j(this).show();
	});
	$j("#progress").ajaxSend(function(){
		$j(this).show();
	});
	
	$j("#progress").ajaxStop(function(){		
		$j(this).hide();
	});
	$j("#progress").ajaxComplete(function(){		
		$j(this).hide();
	});
	
	// Modernizr polyfill which fixes the current jQuery's version of the object, $j.support.transition.end
	// Impacted areas, i.e. bootstrap modal will use the correct transistion browser specific pre-fix needed
	// without having to make changes respectively
    // No longer neccessary..
	if (typeof Modernizr !== "undefined") {
		var transEndEventNames = {
			'WebkitTransition' : 'webkitTransitionEnd',
			'MozTransition'    : 'transitionend',
			'OTransition'      : 'oTransitionEnd',
			'msTransition'     : 'MSTransitionEnd',
			'transition'       : 'transitionend'
		}
		$j.support.transition.end = transEndEventNames[ Modernizr.prefixed('transition') ];
	}
});

// All of Thickbox is Deprecated.
//  use: PopupModal module or AppUtil.notify()
function loadTB(caption, url){
	tb_show(caption,url);
}

// Deprecated; use AppUtil.getTime()
function time(){
	return new Date().getTime();
}
